// Öffentliche API-Clients (kein Auth-Header nötig)

export type PublicUnit = {
  id: number;
  name: string;
  beschreibung: string | null;
  nur_pfadfinder: number;
  nur_mit_einheit_id: number | null;
};

export type PublicCalendarEntry = {
  einheit_id: number;
  einheit_name: string;
  check_in: string;
  check_out: string;
  check_in_time?: string | null;
  check_out_time?: string | null;
  status: string;
};

export type AvailabilityConflict = {
  einheiten_namen: string | null;
  check_in: string;
  check_out: string;
  status: string;
};

export type AvailabilityResult = {
  has_conflict: boolean;
  conflicts: AvailabilityConflict[];
};

export type PublicInquiryPayload = {
  gruppenname: string;
  anrede: string;
  vorname: string;
  nachname: string;
  email: string;
  telefon?: string;
  gruppenart: string;
  adresse_strasse: string;
  adresse_plz: string;
  adresse_ort: string;
  adresse_land?: string;
  check_in: string;
  check_out: string;
  check_in_time?: string;
  check_out_time?: string;
  einheiten_wunsch: string[];
  nachricht?: string;
  datenschutz_ok: boolean;
  website: string; // Honeypot – immer leer lassen
  source?: string;
};

export type PublicInquiryResult = {
  inquiry_id: number;
  status: string;
  verification_required: boolean;
  message: string;
  verify_token?: string | null;
};

async function publicFetch<T>(
  url: string,
  options?: RequestInit,
): Promise<T> {
  const res = await fetch(url, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = await res.json();
      detail = body.detail ?? detail;
    } catch {}
    throw new Error(detail);
  }
  return res.json() as Promise<T>;
}

export function getPublicUnits(): Promise<PublicUnit[]> {
  return publicFetch<PublicUnit[]>("/api/public/units");
}

export function getPublicCalendar(von: string, bis: string): Promise<PublicCalendarEntry[]> {
  return publicFetch<PublicCalendarEntry[]>(`/api/public/calendar?von=${von}&bis=${bis}`);
}

export function checkAvailability(payload: {
  check_in: string;
  check_out: string;
  check_in_time?: string;
  check_out_time?: string;
  einheiten_ids: number[];
}): Promise<AvailabilityResult> {
  return publicFetch<AvailabilityResult>("/api/public/check-availability", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function submitPublicInquiry(payload: PublicInquiryPayload): Promise<PublicInquiryResult> {
  return publicFetch<PublicInquiryResult>("/api/public/inquiry", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
